import React, { Component } from 'react'

import PropTypes from 'prop-types'
import { Field, reduxForm } from 'redux-form'

import { BlankCard } from '../../../../components/ui/cards/BlankCard'
import renderTextInputWithFeedback from '../../../../components/ui/forms/renderTextInputWithFeedback'
import SearchBoxWithSuggestionsFromNetwork from '../../../../components/ui/forms/SearchBoxWithSuggestionsFromNetwork'
import constants from '../../../../utils/constants/application'
import notificationsUtils from '../../../../utils/notifications/notificationsUtils'
import * as demoDuck from '../demoDuck'
import fullstory from '../../../../utils/constants/fullstory'
import formValidators from '../../../../utils/validation/formValidators'

const { autoCompleteIndices } = constants

class DemoClientInfoForm extends Component {
  static propTypes = {
    change: PropTypes.func,
    handleSubmit: PropTypes.func.isRequired,
  }

  constructor(props) {
    super(props)

    this.onDimNameSuggestionSelected = suggestionValue =>
      this.props.change('dimName', suggestionValue)
  }

  render() {
    const { handleSubmit } = this.props

    return (
      <BlankCard delay={0.5}>
        <form onSubmit={handleSubmit}>
          <div className="row justify-content-md-center">
            <div className="col-md-9 pb-3">
              <Field
                name="dimName"
                field={autoCompleteIndices.universityDisplay}
                placeholder="Select client name"
                component={SearchBoxWithSuggestionsFromNetwork}
                label="Client Dim Name"
                onSuggestionSelected={this.onDimNameSuggestionSelected}
                search={false}
                index={autoCompleteIndices.universityDim}
              />
            </div>
          </div>
          <div className="row justify-content-md-center">
            <div className="col-md-9">
              <Field
                name="shortName"
                component={renderTextInputWithFeedback}
                placeholder="SBU"
                label="University Short Name"
                className={fullstory.classNames.textInput}
              />
            </div>
          </div>
          <div className="row justify-content-md-center">
            <div className="col-md-4">
              <Field
                name="logo"
                component={renderTextInputWithFeedback}
                placeholder="steppingblocks.edu or image url"
                label="University Logo URL(optional)"
                className={fullstory.classNames.textInput}
              />
              <i>You can now use any public image url.</i>
            </div>
            <div className="col-md-2 pt-4">
              <label style={{ fontSize: 14, textTransform: 'none', marginRight: 10 }}>
                Audited?
              </label>
              <Field name="audited" component="input" type="checkbox" />
            </div>
            <div className="col-md-3 pt-4">
              <label style={{ fontSize: 14, textTransform: 'none', marginRight: 10 }}>
                School Catalog?
              </label>
              <Field name="schoolCatalog" component="input" type="checkbox" />
            </div>
          </div>
          <div className="row justify-content-md-center">
            <div className="col-md-3 pl-0 text-center" style={{ paddingTop: 23 }}>
              <button
                className="btn btn-primary"
                type="submit"
                style={{ padding: '10px 0', width: '100%' }}
              >
                Submit
              </button>
            </div>
          </div>
        </form>
      </BlankCard>
    )
  }
}

// Form validation function run by redux-form
const validate = values => {
  const errors = {}

  errors.logo = formValidators.maxLengthTwoHundred(values.logo)

  errors.shortName = formValidators.maxLengthTwoHundred(values.shortName)

  errors.dimName = formValidators.isRequired(values.dimName)
    ? formValidators.isRequired(values.dimName)
    : formValidators.maxLengthTwoHundred(values.dimName)

  return errors
}

const demoClientInfoForm = reduxForm({
  form: 'demoClientInfoForm',
  onSubmit: async (values, _dispatch) => {
    const { audited, dimName, logo, schoolCatalog, shortName } = values
    try {
      if (dimName) {
        await _dispatch(
          demoDuck.performSetDemoClientData({
            audited,
            dimName,
            logo,
            schoolCatalog,
            shortName,
          }),
        )
        notificationsUtils.showSuccessNotification('Client info updated successfully.')
      }
    } catch (error) {
      notificationsUtils.showErrorNotification(error.message)
    }
  },
  validate,
})(DemoClientInfoForm)

export default demoClientInfoForm



// WEBPACK FOOTER //
// ./src/routes/authenticated/Demo/components/DemoClientInfoForm.js